<template>
    <div style="width: 200px" class="u-pr2  u-pl2 display-inline-block">
        <span class="display-block u-mb2 u-text--success u-text--center">{{ title }}</span>
        <span>{{color ? color : 'NULL'}}</span>
        <div style="background-color: white" class="u-p2 div-borders" v-if="color">
              <div class="small-div div-borders" :style="'background-color:' + color">{{ color.startsWith('#') ? '' : 'on white' }}</div>
          </div>
          <div style="background-color: black" class="u-p2 div-borders u-mt1" v-if="color && !color.startsWith('#')">
              <div class="small-div div-borders" :style="'background-color:' + color" >on black</div>
          </div>
          <div style="background-color: cyan"  class="u-p2 div-borders u-mt1" v-if="color && !color.startsWith('#')">
              <div class="small-div div-borders" :style="'background-color:' + color">on cyan</div>
          </div>
    </div>
</template>

<script>
  export default {
    name: 'ba-color-sample',
    props: ['title', 'color'],
    data () {
      return {}
    },
    computed: {},
  }
</script>

<style scoped>
  .div-borders {
    border: 1px dotted #000000;
    border-radius: 10px;
  }
  .small-div {
    height: 18px;
  }
</style>